export const EVENTS_TEMPLATES_FETCH_LIST_REQUEST = 'EVENTS_TEMPLATES:FETCH_LIST_REQUEST';
export const EVENTS_TEMPLATES_FETCH_LIST_SUCCESS = 'EVENTS_TEMPLATES:FETCH_LIST_SUCCESS';
export const EVENTS_TEMPLATES_FETCH_LIST_FAILURE = 'EVENTS_TEMPLATES:FETCH_LIST_FAILURE';
export const EVENTS_TEMPLATES_FETCH_REQUEST = 'EVENTS_TEMPLATES:FETCH_REQUEST';
export const EVENTS_TEMPLATES_FETCH_SUCCESS = 'EVENTS_TEMPLATES:FETCH_SUCCESS';
export const EVENTS_TEMPLATES_FETCH_FAILURE = 'EVENTS_TEMPLATES:FETCH_FAILURE';
export const EVENTS_TEMPLATES_DELETE_REQUEST = 'EVENTS_TEMPLATES:DELETE_REQUEST';
export const EVENTS_TEMPLATES_DELETE_SUCCESS = 'EVENTS_TEMPLATES:DELETE_SUCCESS';
export const EVENTS_TEMPLATES_DELETE_FAILURE = 'EVENTS_TEMPLATES:DELETE_FAILURE';
export const EVENTS_TEMPLATES_SAVE_REQUEST = 'EVENTS_TEMPLATES:SAVE_REQUEST';
export const EVENTS_TEMPLATES_SAVE_SUCCESS = 'EVENTS_TEMPLATES:SAVE_SUCCESS';
export const EVENTS_TEMPLATES_SAVE_FAILURE = 'EVENTS_TEMPLATES:SAVE_FAILURE';
export const EVENTS_TEMPLATES_TAGS_FETCH_REQUEST = 'EVENTS_TEMPLATES:FETCH_TAGS_REQUEST';
export const EVENTS_TEMPLATES_TAGS_FETCH_SUCCESS = 'EVENTS_TEMPLATES:FETCH_TAGS_SUCCESS';
export const EVENTS_TEMPLATES_TAGS_FETCH_FAILURE = 'EVENTS_TEMPLATES:FETCH_TAGS_FAILURE';
export const EVENTS_TEMPLATES_TOURS_FETCH_REQUEST = 'EVENTS_TEMPLATES:FETCH_TOURS_REQUEST';
export const EVENTS_TEMPLATES_TOURS_FETCH_SUCCESS = 'EVENTS_TEMPLATES:FETCH_TOURS_SUCCESS';
export const EVENTS_TEMPLATES_TOURS_FETCH_FAILURE = 'EVENTS_TEMPLATES:FETCH_TOURS_FAILURE';
export const EVENTS_TEMPLATES_SET_REDIRECT_URL = 'EVENTS_TEMPLATES:SET_REDIRECT_URL';
export const EVENTS_TEMPLATES_SET_CLUB_ID = 'EVENTS_TEMPLATES:SET_CLUB_ID';
